import React, { useEffect, useState } from "react";
import { broadcastListService } from "../../utils/api";

export function PingstationForm ({ onSubmit, initialData }) {

  // State to store form values
  const [formData, setFormData] = useState({
    airport_code: initialData?.airport_code || "",
    uptime_robot_id: initialData?.uptime_robot_id || "",
    forward_group_id: initialData?.forward_group_id || "",
    enable_uptime_robot: initialData?.enable_uptime_robot || false,
    active: initialData?.active || false,
  });
  const [broadcastList, setBroadcastList] = useState([])

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({
        airport_code: "",
        uptime_robot_id: "",
        forward_group_id: "",
        enable_uptime_robot: false,
        active: false,
    });
  };

  useEffect(() => {
        setFormData({
            airport_code: initialData?.airport_code || "",
            uptime_robot_id: initialData?.uptime_robot_id || "",
            forward_group_id: initialData?.forward_group_id || "",
            enable_uptime_robot: initialData?.enable_uptime_robot || false,
            active: initialData?.active || false,
        })

        broadcastListService((data) => {
            if (data.success) {
                setBroadcastList(data.result)
            }
        })
    }, [initialData]);


    return (
        <div className="pt-6">
        <form onSubmit={handleSubmit} className="space-y-4">
            {/* Airport Code */}
            <div>
            <label className="block text-sm font-medium text-gray-700">Airport Code</label>
            <input
                type="text"
                name="airport_code"
                value={formData.airport_code}
                onChange={handleChange}
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            />
            </div>

            {/* Enable Uptime Robot */}
            <div className="flex items-center">
                <input
                    type="checkbox"
                    name="enable_uptime_robot"
                    checked={formData.enable_uptime_robot}
                    onChange={handleChange}
                    className="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    id="enable_uptime_robot"
                />
                <label for="enable_uptime_robot" className="ml-2 text-sm font-medium text-gray-700">Enable Uptime Robot</label>
            </div>

            {/* Uptime Robot ID */}
            <div>
                <label className="block text-sm font-medium text-gray-700">Uptime Robot ID</label>
                <input
                    type="text"
                    name="uptime_robot_id"
                    value={formData.uptime_robot_id}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                    {...(formData.enable_uptime_robot ? {} : { disabled: true })}
                />
            </div>

            {/* Forward Group ID (Dropdown) */}
            <div>
            <label className="block text-sm font-medium text-gray-700">Forward Boardcast Group</label>
            <select
                name="forward_group_id"
                value={formData.forward_group_id}
                onChange={handleChange}
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            >
                <option value="">Select a Group</option>
                {broadcastList.map((group) => (
                <option key={group.id} value={group.id}>
                    {group.name}
                </option>
                ))}
            </select>
            </div>

            {/* Active Checkbox */}
            <div className="flex items-center">
            <input
                type="checkbox"
                name="active"
                checked={formData.active}
                onChange={handleChange}
                className="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                
                id="active"
            />
            <label for="active"  className="ml-2 text-sm font-medium text-gray-700">Active</label>
            </div>

            {/* Buttons */}
            <div className="flex justify-end space-x-3">
            <button
                type="submit"
                className="px-4 py-2 bg-yellow-500 text-white rounded-md hover:bg-yellow-600"
            >
                Save Changes
            </button>
            </div>
        </form>
        </div>
    );
};